export default "__VITE_ASSET__055af6f3__"